import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { registerSW } from 'virtual:pwa-register';
import App from './App';
import '@paulownia/shared/index.css';
import { Toaster } from 'sonner';
import { ErrorBoundary, initSentry, reportWarning } from '@paulownia/shared';

// Initialize Sentry before anything else
initSentry('customer');

// Register service worker with proper error handling
registerSW({
  onRegistered(registration) {
    if (registration) {
      console.log('Service worker registered successfully');
    }
  },
  onRegisterError(error) {
    // Report to Sentry with context but as warning (non-critical)
    reportWarning('Service worker registration failed', {
      error: error instanceof Error ? error.message : String(error),
      userAgent: navigator.userAgent,
    });
  },
});

// Note: Firebase est initialisé automatiquement lors du premier appel aux services
// Pas besoin d'initialiser explicitement ici pour l'app customer

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <HelmetProvider>
        <BrowserRouter>
          <App />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </HelmetProvider>
    </ErrorBoundary>
  </StrictMode>
);
